// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a9271a12","453":"dc89845d","859":"c1741642"}[chunkId] + ".chunk.js";
};